module.exports = __webpack_public_path__ + "static/media/indices2.204e8020.jpg";